@use '@lib/assets/styles/main.scss' as *;

.separator {
  display: flex;
  justify-content: center;
  color: $gray500;
  position: relative;
  padding: 8px 0;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
    transform: translateY(-50%);
    background-color: $gray200;
    z-index: 1;
  }
  & > div {
    background: $gray0;
    padding: 0 12px;
    position: relative;
    z-index: 2;
  }
}
